import { CCUtils } from "../../../../common/CCUtils"
import { log } from "../../../../common/Logging"
import { MakeVideoSprite, MakeVideoSpriteConfig, MakeVideoSpriteTypes } from "../MakeVideoTypes"
import { MakeAVideoTitleSprite } from "./MakeAVideoTitleSprite"
import { MakeVideoBackgroundSelectContainer } from "./MakeVideoBackgroundSelectContainer"
import { MakeVideoCheeringCrowdSprite } from "./MakeVideoCheeringCrowdSprite"
import { MakeVideoClipPreviewContainer } from "./MakeVideoClipPreviewContainer"
import { MakeVideoIntroBandSprite } from "./MakeVideoIntroBandSprite"
import { MakeVideoIntroTateSprite } from "./MakeVideoIntroTateSprite"
import { MakeVideoMusicButtonContainer } from "./MakeVideoMusicButtonContainer"
import { MakeVideoThoughtBubbleSprite } from "./MakeVideoThoughtBubbleSprite"
import { MakeVideoTitleSelectContainer } from "./MakeVideoTitleSelectContainer"
import { MakeVideoVideoPlayerContainer } from "./MakeVideoVideoPlayerContainer"
import { MakeVideoTimelineTile, MakeVideoVideoTimeline } from "./MakeVideoVideoTimeline"

export class MakeVideoSpriteCreator {

    private activeSprites: Array<MakeVideoSprite>

    constructor(private game: Phaser.Game, private moveToStep: () => void) {
        this.activeSprites = []
    }

    destroyAll = () => {
        this.activeSprites.forEach(sprite => {
            if (sprite.active) {
                sprite.destroy()
            }
        })
        this.activeSprites = []
    }

    create = (type: MakeVideoSpriteTypes, config: MakeVideoSpriteConfig): MakeVideoSprite => {
        const {x, y, tweenX, nextButton, sprites, edit, editButton} = config
        const group = config.group ? config.group : this.game.add.group()
        let sprite: MakeVideoSprite
        switch (type) {
            case MakeVideoSpriteTypes.INTRO_TATE:
                sprite = new MakeVideoIntroTateSprite(this.game, group, x, y, CCUtils.debug)
                break
            case MakeVideoSpriteTypes.INTRO_BAND:
                sprite = new MakeVideoIntroBandSprite(this.game, group, x, y, tweenX, CCUtils.debug)
                break
            case MakeVideoSpriteTypes.CHEERING_CROWD:
                sprite = new MakeVideoCheeringCrowdSprite(this.game, group, x, y, CCUtils.debug)
                break
            case MakeVideoSpriteTypes.THOUGHT_BUBBLE:
                sprite = new MakeVideoThoughtBubbleSprite(this.game, group, x, y, CCUtils.debug)
                break
            case MakeVideoSpriteTypes.TITLE_SPRITE:
                sprite = new MakeAVideoTitleSprite(this.game, group, x, y, CCUtils.debug)
                break
            case MakeVideoSpriteTypes.MUSIC_BUTTONS:
                sprite = new MakeVideoMusicButtonContainer(this.game, group, x, y, nextButton, edit, CCUtils.debug, this.moveToStep)
                break
            case MakeVideoSpriteTypes.VIDEO_TIMELINE:
                sprite = new MakeVideoVideoTimeline(this.game, group, x, y, CCUtils.debug)
                break
            case MakeVideoSpriteTypes.CLIP_PREVIEW:
                const tiles = sprites as Array<MakeVideoTimelineTile>
                sprite = new MakeVideoClipPreviewContainer(this.game, group, x, y, tiles, nextButton, edit, CCUtils.debug, this.moveToStep)
                break
            case MakeVideoSpriteTypes.TITLE_SELECTION:
                sprite = new MakeVideoTitleSelectContainer(this.game, group, x, y, nextButton, edit, this.moveToStep)
                break
            case MakeVideoSpriteTypes.BACKGROUND_SELECTION:
                sprite = new MakeVideoBackgroundSelectContainer(this.game, group, x, y, nextButton, edit, CCUtils.debug, this.moveToStep)
                break
            case MakeVideoSpriteTypes.VIDEO_PLAYER:
                sprite = new MakeVideoVideoPlayerContainer(this.game, group, x, y, edit, nextButton, editButton, CCUtils.debug)
                break
            default:
                log.error("Unrecognized sprite type.")
        }
        this.activeSprites.push(sprite)
        return sprite
    }
}

